import React from 'react';

const STATUS_CONFIG = {
  new:              { label: 'New',             bg: 'rgba(56,133,222,0.1)',  color: '#185FA5' },
  contacted:        { label: 'Contacted',       bg: 'rgba(240,193,82,0.1)', color: '#854F0B' },
  interested:       { label: 'Interested',      bg: 'rgba(127,119,221,0.1)',color: '#534AB7' },
  appointment_set:  { label: 'Appt Set',        bg: 'rgba(29,158,117,0.1)', color: '#0F6E56' },
  policy_sold:      { label: 'Policy Sold',     bg: 'rgba(29,158,117,0.18)',color: '#0F6E56' },
  not_interested:   { label: 'Not Interested',  bg: 'rgba(216,90,48,0.1)',  color: '#A32D2D' },
};

export { STATUS_CONFIG };

// Avatar
export function Avatar({ name = '?', size = 32 }) {
  const initials = name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
  const colors = [
    ['#7F77DD', '#534AB7'],
    ['#1D9E75', '#0F6E56'],
    ['#378ADD', '#185FA5'],
    ['#D85A30', '#A32D2D'],
    ['#BA7517', '#854F0B'],
  ];
  const idx = name.charCodeAt(0) % colors.length;
  const [c1, c2] = colors[idx];
  return (
    <div style={{
      width: size, height: size, borderRadius: '50%',
      background: `linear-gradient(135deg, ${c1}, ${c2})`,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      flexShrink: 0, fontSize: size * 0.38, fontWeight: 700,
      color: '#fff', letterSpacing: '-0.5px', userSelect: 'none',
    }}>
      {initials}
    </div>
  );
}

// StatusBadge
export function StatusBadge({ status }) {
  const cfg = STATUS_CONFIG[status] || { label: status || 'Unknown', bg: 'rgba(155,155,155,0.1)', color: '#666' };
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      padding: '2px 8px', borderRadius: 20,
      background: cfg.bg, color: cfg.color,
      fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap',
    }}>
      {cfg.label}
    </span>
  );
}

// ScoreBar
export function ScoreBar({ score = 0 }) {
  const pct = Math.min(100, Math.max(0, score));
  const color = pct >= 80 ? '#1D9E75' : pct >= 60 ? '#534AB7' : pct >= 40 ? '#BA7517' : '#D85A30';
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <div style={{ flex: 1, height: 4, background: 'var(--bg3)', borderRadius: 2, overflow: 'hidden', minWidth: 48 }}>
        <div style={{ width: pct + '%', height: '100%', background: color, borderRadius: 2, transition: 'width 0.5s ease' }} />
      </div>
      <span style={{ fontSize: 11, fontWeight: 600, color, minWidth: 24, textAlign: 'right' }}>{pct}</span>
    </div>
  );
}

// Card
export function Card({ children, style = {} }) {
  return (
    <div style={{
      background: 'var(--bg2)',
      border: '0.5px solid var(--border)',
      borderRadius: 14,
      boxShadow: 'var(--shadow-sm)',
      overflow: 'hidden',
      ...style,
    }}>
      {children}
    </div>
  );
}

// CardHeader
export function CardHeader({ title, action }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '13px 18px',
      borderBottom: '0.5px solid var(--border)',
      flexShrink: 0,
    }}>
      <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--text)', letterSpacing: '-0.3px' }}>{title}</span>
      {action && <div>{action}</div>}
    </div>
  );
}